interface PreloadedMessagesContainer {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    preload_messages_map?: any;
}

export function getPreloadedMessagesForLocale(locale: string): object {
    // Fetch this object from the Node-JS global scope, or the browser window scope
    const preloadedMap =
        (globalThis !== undefined && (globalThis as PreloadedMessagesContainer)?.preload_messages_map) ||
        (globalThis.window !== undefined && (globalThis.window as PreloadedMessagesContainer)?.preload_messages_map) ||
        undefined;
    return preloadedMap?.[locale] as object;
}
